import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Address,
  AddressError,
  AddressLookupCountries,
  AddressLookupCountry,
  GooglePlacesAddressPlaces,
} from '../models';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LoggerService } from '../../logger';

@Injectable({
  providedIn: 'root',
})
export class GooglePlacesService {
  private readonly googleApiKey = 'AIzaSyDY60G7T7k6O9pCsAcphnDQSI8vfWHtDns';
  private readonly googleApiURL =
    'https://places.googleapis.com/v1/places:searchText';

  private readonly maps: {
    [key in AddressLookupCountry]: {
      [key in
        | 'street_number'
        | 'street'
        | 'suburb'
        | 'state'
        | 'postcode']: string;
    };
  } = {
    Australia: {
      street_number: 'street_number',
      street: 'route',
      suburb: 'locality',
      state: 'administrative_area_level_1',
      postcode: 'postal_code',
    },
    /*
    'New Zealand': {
      street_number: 'street_number',
      street: 'route',
      suburb: 'sublocality_level_1',
      state: 'locality',
      postcode: 'postal_code',
    },
    'United Kingdom': {
      street_number: 'street_number',
      street: 'route',
      suburb: 'postal_town',
      state: 'administrative_area_level_2',
      postcode: 'postal_code',
    },
    Canada: {
      street_number: 'street_number',
      street: 'route',
      suburb: 'locality',
      state: 'administrative_area_level_1',
      postcode: 'postal_code',
    },
    */
  };

  constructor(private http: HttpClient, private logger: LoggerService) {}

  autocomplete(
    query: string,
    queryCountry: AddressLookupCountry
  ): Observable<AddressError | Address[]> {
    const headers: HttpHeaders = new HttpHeaders({
      'X-Goog-Api-Key': this.googleApiKey,
      'X-Goog-FieldMask': 'places.addressComponents',
    });

    return this.http
      .post<GooglePlacesAddressPlaces>(
        this.googleApiURL,
        { textQuery: query + ' ' + queryCountry },
        {
          headers: headers,
        }
      )
      .pipe(
        map((vm) => {
          if (Array.isArray(vm.places)) {
            return vm.places.map((dto) => {
              this.logger.info('GooglePlacesService', 'autocomplete', {
                dto,
              })();
              var resultCountry = dto.addressComponents.find(
                (ac) => ac.types[0] === 'country'
              )?.longText;
              //alternative to just expecting the first entry in the types array to be the type we're looking for
              //var resultCountry = dto.addressComponents.find((ac) => ac.types.includes('country'))?.longText;
              var country =
                (resultCountry &&
                  AddressLookupCountries.includes(resultCountry) &&
                  (resultCountry as AddressLookupCountry)) ||
                queryCountry;
              var street_number = dto.addressComponents.find(
                (ac) => ac.types[0] === this.maps[country].street_number
              )?.shortText;
              var street = dto.addressComponents.find(
                (ac) => ac.types[0] === this.maps[country].street
              )?.shortText;
              var suburb = dto.addressComponents.find(
                (ac) => ac.types[0] === this.maps[country].suburb
              )?.shortText;
              var state = dto.addressComponents.find(
                (ac) => ac.types[0] === this.maps[country].state
              )?.shortText;
              var postcode = dto.addressComponents.find(
                (ac) => ac.types[0] === this.maps[country].postcode
              )?.shortText;

              const address1 = street_number + ' ' + street;
              return {
                address1: address1,
                address2: undefined,
                suburb: suburb,
                state: state,
                postcode: postcode,
              } as Address;
            });
          } else {
            return {
              code: 0,
              message: 'No address found',
            } as AddressError;
          }
        })
      );
  }
}
